import React, { FC } from 'react';
import { Dialog, Grid } from '@mui/material';
import Button from 'components/Button';
import { useLanguage } from 'context/AppContext';
import { ModalContent } from 'pages/DeliveryPortal/DeliveryPortalPage.styles';
import * as Styles from './ApproveAllModal.styles';

interface ApproveAllModalProps {
  open: boolean;
  close: () => void;
  handleApproveAllClick: Function;
}

export type ModalContentType = 'selectItem' | 'selectTray' | 'selectPart' | 'selectSerialNumber';

const ApproveAllModal: FC<ApproveAllModalProps> = ({ open, close, handleApproveAllClick }) => {
  const [language] = useLanguage();
  const handleClose = (): void => {
    close();
  };

  const approveAllClick = (): void => {
    handleApproveAllClick();
    close();
  };

  return (
    <Dialog open={open} maxWidth="xs" fullWidth onClose={handleClose}>
      <ModalContent>
        <Styles.Title variant="h5">{language.DataUpload.approveModal.warning}</Styles.Title>
        <Styles.Subtitle variant="subtitle1">{language.DataUpload.approveModal.approveAllWarningText}</Styles.Subtitle>
        <Grid container justifyContent="space-between">
          <Button onClick={() => handleClose()}>{language.DataUpload.approveModal.goBack}</Button>
          <Button onClick={() => approveAllClick()}>{language.DataUpload.approveModal.approveAll}</Button>
        </Grid>
      </ModalContent>
    </Dialog>
  );
};

export default ApproveAllModal;
